import { render, staticRenderFns } from "./UserProfileBlock.vue?vue&type=template&id=1af25354&scoped=true&"
import script from "./UserProfileBlock.vue?vue&type=script&lang=js&"
export * from "./UserProfileBlock.vue?vue&type=script&lang=js&"
import style0 from "./UserProfileBlock.vue?vue&type=style&index=0&id=1af25354&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af25354",
  null
  
)

export default component.exports